<template>
  <div>
    <h3 class="mx-5 my-5 font-weight-regular">Send Letters</h3>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-card class="elevation-0">
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <vonex-autocomplete
                v-model="searchTemplate"
                :options="fieldConditions"
                label="Select Template"
                hide-details
                outlined
                class="form-control custom-td"
                item-value="id"
                item-text="title"
                :items="letterTemplates"
                :rule="'required'"
                clearable
                @change="selectedTemplate"
              ></vonex-autocomplete>
            </v-col>
            <v-col cols="4">
              <vonex-autocomplete
                v-model="searchCust"
                :options="fieldConditions"
                label="Select Customer"
                hide-details
                outlined
                class="form-control custom-td"
                item-value="custNo"
                item-text="custNo"
                return-object
                :items="customersList"
                :filter="filteredList"
                :search-input.sync="custSearch"
                :rule="'required'"
                clearable
                :disabled="searchTemplate == null"
                @change="selectedCust"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.custNo }} - {{ data.item.businessName }}
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="`${data.item.customerNo} - ${data.item.company}`"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </vonex-autocomplete>
            </v-col>
            <v-col cols="3">
              <vonex-text
                v-model="email"
                label="Enter email to send letter"
                outlined
                name="email address"
                :rule="'required'"
                :disabled="searchCust == null"
              ></vonex-text>
            </v-col>
            <v-col cols="1">
              <v-btn
                class="primary py-7"
                right
                dark
                text
                @click="submit()"
                :disabled="invalid"
                >Send Email</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="text-center px-3">
            <v-card color="primary" class="display-block pa-3" width="1000">
              <h3 class="text-center white--text mb-4">Letter Preview</h3>
              <div
                v-if="searchTemplate == null"
                class="white--text font-italic"
              >
                Please select a template.
              </div>
              <div id="preview" v-else>
                <iframe
                  ref="pdfView"
                  style="width: 100%; height: 100%"
                  frameborder="0"
                  scrolling="no"
                  :src="initialDocFile"
                >
                  <p>It appears your web browser doesn't support iframes.</p>
                </iframe>
              </div>
            </v-card>
          </v-row>
        </v-card-text>
      </v-card>
    </ValidationObserver>
    <v-dialog v-model="loaderDialog" persistent width="400">
      <v-card color="primary" dark>
        <v-card-text class="pt-3 white--text">
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-2 mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <message-alert
      :component="$store.getters[`template/message`]"
    ></message-alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SendLetters",
  data: () => ({
    searchTemplate: null,
    searchCust: null,
    custSearch: "",
    email: "",
    letterTemplates: [],
    customersList: [],
    initialDocFile: "",
    statementDetails: [],
    loaderDialog: false,
    customerDetails: null,
    filename: "",
    message: "Please wait while we are loading customers...",
  }),

  mounted() {
    let vm = this;
    var customerList1 = localStorage.getItem("customerList1");
    var customerList2 = localStorage.getItem("customerList2");
    if (customerList1 != null) {
      this.customersList = [...vm.customersList, ...JSON.parse(customerList1)];
    }
    if (customerList2 != null) {
      this.customersList = [...vm.customersList, ...JSON.parse(customerList2)];
    }
    vm.loadLetterTemplates();
    vm.loadCustomers();
  },
  watch: {
    "customerDetails.customerNo": {
      async handler() {
        const vm = this;
        if (vm.customerDetails == null) {
          return;
        }
        await this.loadStatements();
        if (vm.statementDetails.length) {
          const { currBalance, dateIssued: endMonth } = vm.statementDetails[0];
          vm.customerDetails.balance = Number(currBalance)
            .toFixed(2)
            .toString();
          vm.customerDetails.endMonth = vm.defineMonth(endMonth);
          vm.customerDetails.overdueMonth = vm.statementDetails.length;
          vm.customerDetails.startMonth = vm.defineMonth(
            vm.statementDetails[vm.statementDetails.length - 1].dateIssued
          );
          vm.statementDetails.map((e) => {
            vm.customerDetails.listBillStatement +=
              vm.defineMonth(e.dateIssued) + "<br/>";
          });
          this.submit(true);
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("template", [
      "getLetterTemplate",
      "sendLetterTemplate",
      "setMessage",
    ]),
    ...mapActions("reminders", [
      "getUBCustomers",
      "getUBStatements",
      "importAgedReceivables",
      "loadExcludedGroups",
    ]),
    filteredList(item, queryText) {
      return (
        item.customerNo
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.company
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    loadLetterTemplates() {
      let vm = this;
      vm.getLetterTemplate().then((data) => {
        vm.letterTemplates = data;
      });
    },
    loadCustomers() {
      let vm = this;
      let ubCustomers = [];
      let groups = [];
      if (vm.customersList.length == 0) {
        vm.loaderDialog = true;
      }

      vm.loadExcludedGroups().then((res) => {
        groups = res.map((x) => x.name);
      });
      vm.getUBCustomers()
        .then((data) => {
          ubCustomers = data;
          vm.importAgedReceivables()
            .then((data) => {
              vm.customersList = data
                .map((e) => {
                  let detail = ubCustomers.filter(
                    (cust) => cust.custNo == e.customerNo
                  );
                  return { ...e, ...detail[0] };
                })
                .filter(
                  (cust) =>
                    cust.dateCancelled != null && cust.dateCancelled == ""
                )
                .filter(
                  (cust) =>
                    cust.billRunCycleNumber != null &&
                    parseInt(cust.billRunCycleNumber) >= 1 &&
                    parseInt(cust.billRunCycleNumber) <= 6
                )
                .filter((cust) => groups.includes(cust.groupName))
                .sort((a, b) => Number(a.customerNo) - Number(b.customerNo));
              vm.loaderDialog = false;
              var length = vm.customersList.length;

              localStorage.setItem(
                "customerList1",
                JSON.stringify([...vm.customersList].splice(0, length / 2))
              );
              localStorage.setItem(
                "customerList2",
                JSON.stringify([...vm.customersList].splice(length / 2, length))
              );
            })
            .catch((err) => {
              vm.err = err;
              vm.loaderDialog = false;
            });
        })
        .catch((err) => {
          vm.err = err;
        });
    },
    async loadStatements() {
      let vm = this;
      vm.loaderDialog = true;
      try {
        vm.statementDetails = await vm.getUBStatements({
          custNo: vm.customerDetails.customerNo,
        });
        vm.loaderDialog = false;
        return;
      } catch (error) {
        if (vm.customerDetails && vm.customerDetails.customerNo) {
          vm.setMessage({
            message: "Account doesn't have invoice(s) listed",
            httpStatus: 500,
          }).then((res) => {
            vm.res = res;
            vm.searchCust = null;
          });
          vm.loaderDialog = false;
        }
      }
    },
    selectedTemplate(value) {
      let vm = this;
      let selected = vm.letterTemplates.filter((x) => x.id === value);

      vm.filename = selected[0].docFile;

      if (selected) {
        vm.searchCust = null;
        vm.email = "";
        vm.customerDetails = null;
        this.submit(true);
      }
    },
    generatePreview(preview) {
      if (preview) {
        this.message = "Generating Preview";
      } else {
        this.message = "Submitting";
      }
      this.loaderDialog = true;
    },
    async selectedCust(value) {
      let vm = this;

      if (value) {
        vm.email = value.customerEmail;
        vm.customerDetails = value;
        vm.customerDetails = {
          ...vm.customerDetails,
          ...{
            balance: "0",
            startMonth: "",
            endMonth: "",
            overdueMonth: "0",
            listBillStatement: "",
          },
        };
      }
    },
    defineMonth(date) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return (
        months[new Date(date).getMonth()] + " " + new Date(date).getFullYear()
      );
    },
    submit(preview = false) {
      let vm = this;
      vm.generatePreview(preview);
      let payload = JSON.stringify({});
      if (vm.customerDetails) {
        vm.customerDetails.email = vm.email;
        payload = JSON.stringify(vm.customerDetails);
      }
      vm.sendLetterTemplate({
        filename: vm.filename,
        data: payload,
        preview: preview,
      })
        .then((res) => {
          if (preview) {
            vm.initialDocFile = `${
              process.env.API
            }/api/reminder/GetLetterTemplateFile/${
              payload == "{}" ? "preview" : vm.customerDetails.customerNo
            }-${vm.filename.replace("docx", "pdf")}`;
          }
          vm.loaderDialog = false;
          if (!preview) {
            vm.setMessage({ message: "Email Sent!", httpStatus: 200 });
            vm.searchTemplate = null;
            vm.searchCust = null;
            vm.email = "";
            vm.customerDetails = null;
          }
        })
        .catch((err) => {
          vm.loaderDialog = false;
          vm.err = err;
        });
    },
  },
};
</script>

<style scoped>
.v-btn--right,
.float-right {
  float: right;
}
.display-block {
  display: block;
  width: 100%;
  margin: 0 auto;
}
</style>
